var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotifyGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C6.0426 0 0 6.0426 0 13.5C0 20.9574 6.0426 27 13.5 27C20.9574 27 27 20.9574 27 13.5C27 6.0426 20.9574 0 13.5 0ZM19.6938 19.4724C19.4508 19.872 18.9324 19.9962 18.5382 19.7532C15.3684 17.8146 11.3778 17.3772 6.6798 18.4518C6.2262 18.5544 5.778 18.2736 5.67 17.82C5.5674 17.3664 5.8482 16.9182 6.3018 16.8102C11.4426 15.633 15.8544 16.1406 19.413 18.3168C19.8072 18.5598 19.9368 19.0782 19.6938 19.4724ZM21.3462 15.795C21.0384 16.2918 20.3958 16.4484 19.899 16.1406C16.2702 13.9104 10.7406 13.2624 6.4476 14.5692C5.8914 14.7366 5.3028 14.4234 5.1354 13.8672C4.968 13.311 5.2812 12.7224 5.8374 12.555C10.7406 11.0646 16.8372 11.7882 21.0006 14.3478C21.4974 14.6502 21.6486 15.2982 21.3462 15.795ZM21.4866 11.9664C17.1342 9.3798 9.9576 9.1422 5.805 10.4058C5.1354 10.6056 4.4334 10.233 4.2282 9.5634C4.0284 8.8938 4.401 8.1918 5.0706 7.9866C9.8388 6.5394 17.766 6.8202 22.7772 9.7902C23.3766 10.1466 23.5764 10.9188 23.22 11.5182C22.8636 12.1176 22.086 12.3174 21.492 11.961L21.4866 11.9664Z",
    fill: "url(#paint0_linear_2_154)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_154",
    x1: 13.5,
    y1: 0,
    x2: 13.5,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAD13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#E6965C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#BF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36AC5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotifyGradient);
export default __webpack_public_path__ + "static/media/SPOTIFY_gradient.59267dc9cd47991bbc4fe3f95236fddb.svg";
export { ForwardRef as ReactComponent };